import React from 'react';
import { Modal, Form, Input, FormInstance } from 'antd';
import validateStyles from './index.module.less';

/** 默认与历史行为一致：手机号后 6 位；portal 入口使用完整身份证号 */
export type ValidateModalVerificationMode = 'phoneLast6' | 'idCardLast6' | 'idCardFull';

const ValidateModal = React.memo(
  ({
    visible,
    isSubmitting,
    onOk,
    form,
    verificationMode = 'phoneLast6',
    title = '身份验证',
  }: {
    visible: boolean;
    isSubmitting: boolean;
    onOk: () => void;
    form: FormInstance;
    verificationMode?: ValidateModalVerificationMode;
    title?: string;
  }) => {
    const isIdCardLast6 = verificationMode === 'idCardLast6';
    const isIdCardFull = verificationMode === 'idCardFull';
    const rules = isIdCardFull
      ? [
          { required: true, message: '请输入18位身份证号' },
          {
            pattern: /^(\d{17}[\dXx])$/,
            message: '请输入正确的18位身份证号',
          },
        ]
      : isIdCardLast6
      ? [
          { required: true, message: '请输入身份证号码后 6 位' },
          {
            pattern: /^[0-9]{5}[0-9Xx]$/,
            message: '前 5 位须为数字，末位可为数字或 X',
          },
          { len: 6, message: '须为 6 个字符' },
        ]
      : [
          { required: true, message: '请输入患者手机号后 6 位' },
          { pattern: /^\d{6}$/, message: '手机号后 6 位必须是数字' },
          { len: 6, message: '请输入手机号正确的后 6 位数字' },
        ];

    return (
      <Modal
        title={title}
        open={visible}
        onOk={onOk}
        closable={false}
        okText="确定"
        cancelButtonProps={{ style: { display: 'none' } }}
        okButtonProps={{
          style: { width: '100%', height: 40, fontSize: 16 },
          disabled: isSubmitting
        }}
        confirmLoading={isSubmitting}
        transitionName=""
        destroyOnHidden={false}
      >
        <div className={validateStyles.content}>
          <Form form={form} layout="vertical">
            <Form.Item
              name="idCard"
              rules={rules}
              shouldUpdate={false}
            >
              <Input
                placeholder={
                  isIdCardFull
                    ? '请输入18位身份证号'
                    : isIdCardLast6
                    ? '身份证后 6 位'
                    : '请输入患者手机号后6位'
                }
                style={{ width: '100%' }}
                maxLength={isIdCardFull ? 18 : 6}
                disabled={isSubmitting}
              />
            </Form.Item>
          </Form>
        </div>
      </Modal>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.visible === nextProps.visible &&
      prevProps.isSubmitting === nextProps.isSubmitting &&
      prevProps.form === nextProps.form &&
      prevProps.onOk === nextProps.onOk &&
      prevProps.verificationMode === nextProps.verificationMode &&
      prevProps.title === nextProps.title
    );
  }
);

export default ValidateModal;
